import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import FileContent from './FileContent';
import FileSideBar from './FileSidebar';

const ContainerFileManager = () => {
  return (
    <>
      <Container fluid={true}>
        <Breadcrumbs justify='end' pageTitle='File Manager' title='File Manager' />
        <Row>
          <FileSideBar />
          <FileContent />
        </Row>
      </Container>
    </>
  );
};

export default ContainerFileManager;
